/**
 * Centralized logic for user access control.
 *
 * Handles access control by leveraging UI Router transition hooks.
 *
 * @type {ngRun}
 * @see https://ui-router.github.io/ng1/docs/latest/classes/transition.transition-1.html
 */
function tmrAccessControlRun($transitions, UserStorage, TmrAppConfiguration) {
  'ngInject'
  let hasAccess = trans => UserStorage.access(trans.targetState().state())
  let isAnon = trans =>
    UserStorage.isAuthenticated()
      ? null
      : trans.router.stateService.target('app.login')
  let isAuth = trans =>
    UserStorage.isAuthenticated()
      ? trans.router.stateService.target('app')
      : null

  // Abort transition if user has no access.
  $transitions.onBefore(
    {
      to: state =>
        state.accessControl !== undefined && state.accessControl.length > 0,
    },
    trans => {
      const injector = trans.injector()
      return injector
        .getAsync('loggedUser')
        .then(() => TmrAppConfiguration.$promise)
        .then(() => hasAccess(trans))
    },
    { priority: 998 }
  )

  // Redirect to login state if user is not authenticated.
  $transitions.onBefore(
    { to: state => !state.accessAnonymous },
    trans =>
      trans
        .injector()
        .getAsync('loggedUser')
        .then(() => isAnon(trans)),
    { priority: 999 }
  )

  // Redirect from login to front page if user is authenticated.
  $transitions.onBefore({ to: 'app.login' }, trans =>
    trans
      .injector()
      .getAsync('loggedUser')
      .then(() => isAuth(trans))
  )
}

export { tmrAccessControlRun as run }
